import {Component, EventEmitter, OnDestroy, Output} from '@angular/core';
import {FormArray, FormBuilder, FormGroup} from '@angular/forms';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
	selector: 'app-filter-map',
	templateUrl: './filter-map.component.html',
	styleUrls: ['./filter-map.component.scss']
})
export class FilterMapComponent implements OnDestroy {
	private onDestroy$ = new Subject<void>();
	test = false;
	filterFormMap: FormGroup;
	filterFormArray = [
		{
			name: '<b>EAM</b> Store',
			value: 'store',
			isOpen: false,
			description: 'Test Description'
		},
		{
			name: '<b>EAM.GO</b> Fridge',
			value: 'fridge',
			isOpen: false,
			description:
				'Unsere autonomen Fridges versorgen dich 24/7 mit einer Selection aus dem umfangreichen Bio Sortiment von EAM. Je nach Standort sind u.a. verfügbar: Ready-to-Eat Produkte, Cold Drinks, Snacks und Fruits. Zum Öffnen des Fridges benötigst du ein kontaktloses Zahlungsmittel wie eine Kreditkarte, Apple Pay oder eine EC Karte, die ein kontaktloses Zahlen unterstützt.'
		},
		{
			name: 'Geschlossene Outlets ausblenden',
			value: 'isOpen',
			isOpen: false,
			description: ''
		}
	];
	@Output() filtersValue = new EventEmitter<string[]>();
	get dietArr(): FormArray {
		return this.filterFormMap.get('data') as FormArray;
	}
	constructor(private fb: FormBuilder) {
		this.createReactiveForm();
	}
	ngOnDestroy(): void {
		this.onDestroy$.next();
	}
	createReactiveForm() {
		this.filterFormMap = this.fb.group({
			data: this.fb.array([])
		});
		this.addData(this.filterFormArray);

		this.filterFormMap.valueChanges.pipe(takeUntil(this.onDestroy$)).subscribe(v => console.log(v));
	}
	emitFilters() {
		const res = this.filterFormMap?.value?.data.filter(d => d.selected).map(it => it.value);
		this.filtersValue.emit(res);
	}
	addData(arr: {name: string; value: string; isOpen: boolean}[]) {
		const creds = this.filterFormMap.controls.data as FormArray;
		arr.forEach(element => {
			if (element) {
				creds.push(
					this.fb.group({
						name: element.name,
						value: element.value,
						selected: false,
						isOpen: element.isOpen
					})
				);
			}
		});
	}
	changeIsOpenDiet(index: number) {
		const formControlsArray = <FormArray>this.filterFormMap.controls['data'];
		formControlsArray.controls[index].patchValue({
			isOpen: formControlsArray.controls[index]?.value ? !formControlsArray.controls[index]?.value?.isOpen : false
		});
	}

	identify(index, item) {
		return item.id;
	}
}
